import * as React from 'react';
import { connect } from 'react-redux';
import { setGrupoPlanes } from '../../actions/planesActions';

class TablaGrupoPlanes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            request: null,
            descripcion: "",
            comision: 0,
        }
    };

    borrarFila = (idGrupoPlan) => {
        let grupoPlanes = JSON.stringify(this.props.grupoPlanes);
        if (grupoPlanes != "[]") {
            let index = this.props.grupoPlanes.findIndex(x => x.idGrupoPlan == idGrupoPlan);
            this.props.grupoPlanes.splice(index, 1);
            this.props.setGrupoPlanes(this.props.grupoPlanes);
            this.forceUpdate();
        }
    }


    render() {
        return (
            <table class="table">
                <thead>
                    <tr>
                        <th class="div-center">ID</th>
                        <th class="div-center">Descripción</th>
                        <th class="div-center">Comisión</th>
                    </tr>
                </thead>
                <tbody>
                {
                    this.props.grupoPlanes.map((item) => {
                        return (<tr className="hover-background-color">
                            <td class="div-center">{item.idGrupoPlan}</td>
                            <td class="div-center">{item.descripcion}</td>
                            <td class="div-center">{item.comision}</td>
                            <td onClick={() => this.borrarFila(item.idGrupoPlan)}>
                                <i class="fas fa-trash-alt" />
                            </td>
                        </tr>)
                    })
                }
                </tbody>
            </table>
        );
    }
}


const mapStateToProps = state => ({
    grupoPlanes: state.planes.grupoPlanesBusqueda
});

export default connect(mapStateToProps, { setGrupoPlanes })(TablaGrupoPlanes); 